import * as React from 'react';
import Table from 'antd/lib/table';
import Selector from '../../Components/Selector';
import { Link, RouteComponentProps } from 'react-router-dom';
import { IPageOptions } from '../../Models/Common';
import { IPage, IProfile } from '../../Models/Security';
import { IAccount, EAccountStatus, IAccountForm } from '../../Models/Account';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import Icon from 'antd/lib/icon';
import PopConfirm from 'antd/lib/popconfirm';
import Emply from 'antd/lib/empty';
import Row from 'antd/lib/row';
import Balloon from '../../Components/Balloon';
import './ListAccount.scss';
import Pagination from 'antd/lib/pagination';
import DialogBranch from './DialogBranch';
import Button from 'antd/lib/button';
import Search from 'antd/lib/input/Search';
import EventUtils from '../../Utils/EventUtils';
import Drawer from 'antd/lib/drawer';
import IconSearch from '../../Components/IconSearch';
import { ChangePassword } from '../../Components/Profile/ChangePass';
import { EStatusRequest } from '../../Reducers/Session';

export interface IListAccountProps extends RouteComponentProps {
	data: IPage<IAccount>;
	isRequest: boolean;
	profiles: IProfile[];
	current?: IAccount;
	onClean: () => void;
	onFetch: (id: number) => void;
	onFetchData: (options: IPageOptions, idProfile?: number, search?: string, order?: string) => void;
	onDelete: (id: number) => void;
	onChangeStatus: (account: IAccountForm, id?: number) => void;
	status: EStatusRequest;
	setStatusRequest: (status: EStatusRequest) => void;
}

const locale = {
	emptyText: (<Emply description="No tenemos datos para mostrar" />)
  };

const ListAccount = (props: IListAccountProps) => {
	const [openFaena, setOpenFaena] = React.useState(false);
	const [openChangePass, setChangePass] = React.useState(false);
	const [profile, setProfile] = React.useState(undefined);
	const [search, setSearch] = React.useState('');
	const [pageOption, setPageOption] = React.useState({ page: 0, size: 5 });
	const [openDrawer, setOpenDrawer] = React.useState(false);
	const [record, setRecord] = React.useState<IAccount>();
	const onPage = (page: number, size?: number) => {
		const option = { page: page, size: size };
		setPageOption(option as any);
		props.onFetchData({
			page: page - 1,
			size: size || 5
		}, profile, search);
	}
	const onSort = (pagination: any, filter: any, sorter: any) => {
		props.onFetchData(pageOption, profile, search, sorter.columnKey);
	}
	const onToggle = (id?: number) => {
		setOpenFaena(!openFaena);
		if (!id) {
			props.onClean();
		} else {
			props.onFetch(id);
		}
	}

	const onSearch = (str?: string) => {
		return () => {
			props.onFetchData({ page: 0, size: 5 }, profile, str);
		}
	}

	const onCloseChangePass = () => {
			setChangePass(false);
			setRecord(undefined);
			props.setStatusRequest(EStatusRequest.PENDING);
	}

	const onChangePass = (account?: IAccount) => {
		setChangePass(!openChangePass);
		setRecord(account);
	}

	const showDrawer = (record?: IAccount) => {
		setOpenDrawer(record ? true : false);
		setRecord(record);
	}

	const sendPass = (data: any) => {
		if (record) {
			const dataSend: any = {...record, cleanPassword: data.passwordNew, password: undefined, brandsAdd: [], brandsDel: []}
			props.onChangeStatus(dataSend, record.id);
		}
	}

	return (<div className="ListAccount">
		<DialogBranch loading={props.isRequest} toggle={onToggle} open={openFaena} current={props.current} />
		<h1>Administración de cuentas de usuario</h1>
		<Selector
			data={props.profiles.map(p => ({ label: p.description, value: p.id }))}
			placeholder="Seleccionar perfil de usuario"
			onChange={(value: any) => {
			setProfile(value);
			props.onFetchData({ page: 0, size: 5 }, value, search)
		}} />
		<div className="ListAccount-Table" >
			<div className="Header-table">
				<div className="Container-Search">
					<Search placeholder="Buscar usuario" prefix={false} suffix={false} onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {

							const value: any = evt.target.value
							setSearch(value);
							EventUtils.debounce(onSearch(value), 500);

						}
						} />
						<IconSearch />
				</div>
			</div>
			{openDrawer && <Drawer
          title="Información de Usuario"
          placement="right"
          closable={false}
          onClose={() => showDrawer()}
          visible={openDrawer}
					getContainer={false}
					className="hidden-large"
          style={{ position: 'absolute' }}
        >
					{record && <div>
          <p>
						<strong>Nombre: </strong>{record!.name}
					</p>
					<p>
						<strong>Correo: </strong>{record!.username}
					</p>
					<p>
						<strong>Perfil: </strong>{record!.profile.description}
					</p>
					<p>
						<strong>Faenas: </strong>
						<span>{record!.quantityBranch}</span>
						{record!.quantityBranch > 0 && <div className="btn-detail" onClick={() => onToggle(record!.id)}>Ver Detalle</div>}
					</p>
					<p>
						<strong>Estatus: </strong>
						<Row className="ListAccount-Table-Status" type="flex">
							<Balloon size={10} color={record!.status === EAccountStatus.ACTIVE ? 'green' : 'red'} />
							<span>{record!.status === EAccountStatus.ACTIVE ? 'Cuenta activa' : 'Cuenta inactiva'}</span>
						</Row>
					</p>
					</div>}
			</Drawer>}
			<Table locale={locale} onChange={onSort} rowKey={(record: IAccount) => `account-row-${record.id}`} loading={props.isRequest} pagination={false} dataSource={props.data.data}>
				<Table.Column dataIndex="name" title="Nombre" />
				<Table.Column dataIndex="username" title="Correo" />
				<Table.Column className="Show-Medium" render={(text: string, record: IAccount)  =>  {
					return <div className="ant-btn ant-btn-link" onClick={() => showDrawer(record)}><Icon type="eye" /></div>;
				}} title="" />
				<Table.Column className="Hidden-Medium" dataIndex="profile.description" title="Perfil" />
				<Table.Column className="Hidden-Medium" title="Faenas" render={(text: string, record: IAccount, index: number) => {
					const faenas = `${record.quantityBranch || 0} Faenas`;
					return <div className="btns-faena">
						<div>{faenas}</div>
						{record.quantityBranch > 0 && <div className="btn-detail" onClick={() => onToggle(record.id)}>Ver Detalle</div>}
					</div>;
				}} />
				<Table.Column className="Hidden-Medium" title="Estatus" render={(text: string, record: IAccount, index: number) => {
					const color = record.status === EAccountStatus.ACTIVE ? 'green' : 'red';
					const status = record.status === EAccountStatus.ACTIVE ? 'Cuenta activa' : 'Cuenta inactiva';
					return <Row className="ListAccount-Table-Status" type="flex">
						<Balloon size={10} color={color} />
						<span>{status}</span>
					</Row>
				}} />
				<Table.Column title="" className="btn-animate" render={(text: string, record: IAccount, index: number) => {
					const menu = <Menu>
						<Menu.Item>
							<div className="ant-btn ant-btn-link" onClick={() => {
								record.status = record.status !== EAccountStatus.ACTIVE ? EAccountStatus.ACTIVE : EAccountStatus.INACTIVE;
								props.onChangeStatus(record as any, record.id);
							}}>
								{record.status === EAccountStatus.ACTIVE ? 'Bloquear usuario' : 'Habilitar Usuario'}
							</div>
						</Menu.Item>
						<Menu.Item>
							<PopConfirm onConfirm={() => props.onDelete(record.id)} title="¿ Está seguro de eliminar este usuario ?" okText="Si" cancelText="No">
								<div className="ant-btn ant-btn-link" >
									Eliminar usuario
							</div>
							</PopConfirm>
						</Menu.Item>
						<Menu.Item>
							<div className="ant-btn ant-btn-link">
								<Link to={`/administration/edit/${record.id}`}>
									Editar usuario
								</Link>
							</div>
						</Menu.Item>

						<Menu.Item>
							<div onClick={() => onChangePass(record)} className="ant-btn ant-btn-link">
								Cambiar Contraseña
							</div>
						</Menu.Item>
					</Menu>;
					return <Dropdown overlay={menu} placement="bottomCenter">
						<div className="ant-btn ant-btn-link">
								<Icon type="more" />
						</div>
					</Dropdown>;
				}} />
			</Table>
		</div>
		{record && <ChangePassword
			isBox={false}
			status={props.status as any}
			onChangeStatus={props.setStatusRequest as any}
			hiddenOld={true}
			onClose={onCloseChangePass}
			isOpen={openChangePass}
			email={record ?  record.username : ''}
			onChange={sendPass}
		/>}
		<div className="ListAccount-Footer">
			<Pagination onChange={onPage} size="small" current={props.data.meta.page + 1} pageSize={props.data.meta.size} total={props.data.meta.total} />
			<Link className="Button-New" to="/administration/create">
				<Button>Nuevo Usuario</Button>
			</Link>
		</div>
	</div>)
}


export default ListAccount;
